// src/core/hooks/use-header-scrolled.ts
"use client"

import { useEffect, useState, useRef } from "react"

const ENTER_THRESHOLD = 40 // بالاتر از این بره تو حالت scrolled
const EXIT_THRESHOLD = 10  // پایین‌تر از این برگرده به حالت اولیه

export function useHeaderScrolled() {
  const [scrolled, setScrolled] = useState(false)
  const scrolledRef = useRef(false)
  const ticking = useRef(false)

  useEffect(() => {
    const onScroll = () => {
      if (ticking.current) return
      ticking.current = true

      requestAnimationFrame(() => {
        const y = window.scrollY
        if (!scrolledRef.current && y > ENTER_THRESHOLD) {
          scrolledRef.current = true
          setScrolled(true)
        } else if (scrolledRef.current && y < EXIT_THRESHOLD) {
          scrolledRef.current = false
          setScrolled(false)
        }
        ticking.current = false
      })
    }

    window.addEventListener("scroll", onScroll, { passive: true })
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  return scrolled
}